import { client } from './client.js';
export const getRankings = () => client('/api/get-rankings');